export const degreeString = number => {
  let deg = parseInt(number);
  var residue = (number - Number(deg)) * 60.0;
  let min = parseInt(residue);
  residue = (residue - Number(min)) * 60.0;
  let sec = parseInt(residue);
  return deg + "°" + zeroPadding(min, 2) + "′" + zeroPadding(sec, 2) + "″";
};

export const zeroPadding = (num, length) => {
  return ("0000000000" + num).slice(-length);
};

export const toPlusMinusSignString = num => {
  let flg = Math.sign(num);
  if (flg === 1) {
    return `+${num.toLocaleString()}`;
  }

  if (flg === -1) {
    return `${num.toLocaleString()}`;
  }

  return String(0);
};

export const parseComma = (num, round) => {
  if (isNaN(num)) return "-";
  return parseFloat(num.toFixed(round)).toLocaleString();
};

/**
 * digitで指定した小数点以下切りさげ
 *
 * @param param
 * @param digit
 * @returns {number}
 */
export const toFloor = (param, digit) => {
  if (isNaN(param)) {
    throw new Error("Error Truncate Digit: " + param);
  }
  return Math.floor(Number(param) * 10 ** digit) / 10 ** digit;
};

/**
 * digitで指定した小数点以下切り捨て
 *
 * @param param
 * @param digit
 * @returns {number}
 */
export const toTrunc = (param, digit) => {
  if (isNaN(param)) {
    throw new Error("Error Truncate Digit: " + param);
  }
  return Math.trunc(Number(param) * 10 ** digit) / 10 ** digit;
};
